/**
 * Centralised mapping from an Adyen card brand string to the corresponding
 * Font Awesome icon class. Same mapping was previously duplicated in 5+
 * components (ReviewAndPayStep, WalletTopUpReview, RepayInvoiceDialog,
 * BuyCreditsDialog, PaymentMethodsPanel).
 *
 * Adyen exposes brands in various casings (Visa, VISA, mastercard…), so we
 * normalise to lowercase and check substrings to be tolerant.
 */
export function brandIconFor(brand: string | null | undefined): string {
  const b = (brand ?? '').toLowerCase();
  if (b.includes('visa')) return 'fa-brands fa-cc-visa';
  if (b.includes('master')) return 'fa-brands fa-cc-mastercard';
  if (b.includes('amex') || b.includes('american')) return 'fa-brands fa-cc-amex';
  if (b.includes('discover')) return 'fa-brands fa-cc-discover';
  return 'fa-regular fa-credit-card';
}
